import { css } from 'lit';
export const timeElementStyles = css `
  :host {
    display: table;
    contain: content;
    font-variant-numeric: tabular-nums;
  }

  :host([hidden]) {
    display: none;
  }
`;
